import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EmailRegex, HtmlTagsRegex, NameRegex, PasswordRegex } from './validation.config';

@Injectable()
export class ValidationService {
  static checkValidation(controlName: string, control: AbstractControl, regex: RegExp): { [x: string]: boolean } | null {
    if (control.value && !regex.test(control.value)) {
      return { [controlName]: true };
    }
    return null;
  }

  validateName(name): { [x: string]: boolean } {
    return ValidationService.checkValidation('name', name, NameRegex);
  }

  validatePassword(password): { [x: string]: boolean } {
    return ValidationService.checkValidation('password', password, PasswordRegex);
  }

  validateEmail(email): { [x: string]: boolean } {
    return ValidationService.checkValidation('email', email, EmailRegex);
  }

  clearHtmlTags(value: string, replaceWith: string): string {
    if (!value) return '';
    return value.replace(HtmlTagsRegex, replaceWith || '');
  }
}
